import { Action, createAction } from 'redux-actions';

import { ModifyPassenger } from '../../../enums';
import { PassengersState } from './reducers';

export const ADD_PASSENGER = 'ADD_PASSENGER';
export const REMOVE_PASSENGER = 'REMOVE_PASSENGER';
export const SET_PASSENGERS = 'SET_PASSENGERS';
export const CLEAR_PASSENGERS = 'CLEAR_PASSENGERS';

export const addPassenger = createAction<ModifyPassenger>(ADD_PASSENGER);
export const removePassenger = createAction<ModifyPassenger>(REMOVE_PASSENGER);
export const setPassengers = createAction(SET_PASSENGERS, (passengers: PassengersState) => passengers);
export const clearPassengers = createAction(CLEAR_PASSENGERS);

export type PassengerAction = Action<ModifyPassenger>;
export type SetPassengersAction = Action<PassengersState>;
